// The store tells the native shell only conclusive session changes, never a credential.
// The Mac's shell and the iPhone's (ios/, Poulpe-623) keep the session the same way,
// with the same messages.
import { inMacShell, tellShell } from '../lib/shell'
import type { BoardStoreOptions } from '../store/store'

export function nativeSessionOptions(): Pick<BoardStoreOptions, 'onSessionState' | 'offlineSessionAllowed'> {
  if (!inMacShell() && !inPhoneShell()) return {}
  // Only an explicitly built unsigned app keeps the previous WebKit-only session.
  if (globalThis.document.documentElement.dataset.sessionMode === 'webkit-development') return {}
  const document = globalThis.document.documentElement.dataset.sessionDocument
  if (!document) return { offlineSessionAllowed: false }
  let revision = 0
  return {
    offlineSessionAllowed: globalThis.document.documentElement.dataset.sessionPresent === '1',
    onSessionState: (state) => tellShell({ sessionState: { document, revision: ++revision, state } }),
  }
}

/** True inside the iPhone app's web view, which marks its page `data-shell="ios"`. */
function inPhoneShell(): boolean {
  return typeof document !== 'undefined' && document.documentElement.getAttribute('data-shell') === 'ios'
}
